// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__1zc6p","contactContainer":"Contact_contactContainer__ZWHmF","buttonRow":"Contact_buttonRow__JcqWW"};